import React from 'react';
import { ProductBackgroundAuth } from '../../components/auth/ProductBackgroundAuth';
export function TrialPage() {
  const handleTrial = (data: any) => {
    console.log('Trial signup data:', data);
    // Handle trial signup logic here
    setTimeout(() => {
      window.location.href = '/';
    }, 1500);
  };
  return <ProductBackgroundAuth mode="signup" onSubmit={handleTrial} data-id="element-8008" />;
}